import { Activity, Mail, MessageCircle } from "lucide-react";
import React from "react";
import { BRAND } from "../../lib/config";
import Button from "../ui/Button";
import Card from "../ui/Card";
import Container from "../ui/Container";
import SectionTitle from "../ui/SectionTitle";

const supportChannels = [
    {
        title: "Discord Support",
        description:
            "Fast answers from humans and community experts, ideal for quick setup questions.",
        href: BRAND.discordUrl,
        cta: "Chat on Discord",
        icon: MessageCircle,
        badge: "Fastest response",
    },
    {
        title: "Email Support",
        description:
            "Account changes, billing questions, and anything that needs a paper trail.",
        href: "mailto:contact@xahosting.com",
        cta: "Email support",
        icon: Mail,
        badge: "24/7 queue",
    },
    {
        title: "Status & Incidents",
        description:
            "Live incident updates, planned maintenance, and historical uptime reports.",
        href: BRAND.statusUrl,
        cta: "View status",
        icon: Activity,
        badge: "Live updates",
    },
];

export default function SupportOptions() {
    return (
        <section className="bg-[#070A0F] pb-24 pt-10">
            <Container>
                <SectionTitle
                    eyebrow="CONTACT OPTIONS"
                    title="Choose the fastest route to resolution"
                    subtitle="Pick the channel that matches your request. We route critical incidents to on-call staff automatically."
                />
                <div className="mt-12 grid gap-6 md:grid-cols-3">
                    {supportChannels.map((channel) => {
                        const Icon = channel.icon;
                        return (
                            <Card
                                key={channel.title}
                                className="flex h-full flex-col p-6"
                            >
                                <div className="flex items-center justify-between">
                                    <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-white/10 bg-white/5">
                                        <Icon className="h-5 w-5 text-cyan-300" />
                                    </div>
                                    <span className="rounded-full bg-white/5 px-3 py-1 text-xs text-white/60">
                                        {channel.badge}
                                    </span>
                                </div>
                                <h3 className="mt-5 text-lg font-semibold text-white">
                                    {channel.title}
                                </h3>
                                <p className="mt-3 text-sm leading-6 text-white/70">
                                    {channel.description}
                                </p>
                                <div className="mt-6">
                                    <Button
                                        href={channel.href}
                                        className="w-full"
                                    >
                                        {channel.cta}
                                    </Button>
                                </div>
                            </Card>
                        );
                    })}
                </div>
            </Container>
        </section>
    );
}
